import React from "react"
import { Link } from "gatsby"

const OpenPositionProf = ({ jobs }) => {
  const [keyVal, setKeyVal] = React.useState("")
  const [keyValue, setKeyValue] = React.useState("")

  const handleChange = e => {
    setKeyVal(e.target.value)
  }
  const handleClick = () => {
    const fil = jobs.filter(item => {
      const job = item.title.toLowerCase()
      return job.includes(keyVal.toLowerCase())
    })
    setKeyValue(fil)
  }

  return (
    <div>
      <div className="py-5">
        <div className="search-job col-10 mx-auto">
          <div className="position-relative">
            <label htmlFor="search" className="label-search">
              <i className="fa fa-search" aria-hidden="true"></i>
            </label>
            <input
              type="text"
              name="search"
              id="search"
              className="w-100"
              placeholder="Search keywords"
              onChange={handleChange}
            />
            <button onClick={handleClick}>Search</button>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="row justify-content-center">
            {keyValue.length !== 0
              ? keyValue.map(pos => (
                  <div className="col-md-6 mb-4">
                    <div className="position-card h-100">
                      <Link
                        to={`/${pos ? pos.slug.current : ""}`}
                        className="h3"
                      >
                        {pos.title}
                      </Link>

                      {pos.careerCategories.map(item => (
                        <span className="text-muted text-uppercase font-weight-bold d-block mb-2">
                          {item.title}
                        </span>
                      ))}

                      <p className="m-0">{pos.excerpt}</p>
                      <div className="d-block my-3">
                        {pos.location ? (
                          <span className="job-deets">
                            <i className="fa fa-map-marker pr-1" />
                            {pos.location}
                          </span>
                        ) : null}
                        <span className="job-deets">{pos._createdAt}</span>
                      </div>
                      <Link
                        className="my_card_readmore has-arrow"
                        to={`/${pos ? pos.slug.current : ""}`}
                      >
                        Apply Now <i className="fa fa-arrow-right" />
                      </Link>
                    </div>
                  </div>
                ))
              : jobs.map(pos => (
                  <div className="col-md-6 mb-4">
                    <div className="position-card h-100">
                      <Link
                        to={`/${pos ? pos.slug.current : ""}`}
                        className="h3"
                      >
                        {pos.title}
                      </Link>
                      {pos.careerCategories.map(item => (
                        <span className="text-muted text-uppercase font-weight-bold d-block mb-2">
                          {item.title}
                        </span>
                      ))}
                      <p className="m-0">{pos.excerpt}</p>
                      <div className="d-block my-3">
                        {pos.location ? (
                          <span className="job-deets">
                            <i className="fa fa-map-marker pr-1" />
                            {pos.location}
                          </span>
                        ) : null}
                        <span className="job-deets">{pos._createdAt}</span>
                      </div>
                      <Link
                        className="my_card_readmore has-arrow"
                        to={`/${pos ? pos.slug.current : ""}`}
                      >
                        Apply Now <i className="fa fa-arrow-right" />
                      </Link>
                    </div>
                  </div>
                ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OpenPositionProf
